import { Grid, Typography, styled } from "@mui/material";

export const MainContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
});

export const Container = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
});

export const InfoContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "10px",
});

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));
